import { type ExclusionAreaFeature } from './exclusionAreaTypeResolution'

export const findDuplicatesFeaturesNamesIndexes = (
  features: ExclusionAreaFeature[] | null | undefined,
): number[] => {
  if (!features?.length) return []

  const indexesByName = new Map<string, number[]>()

  features.forEach(({ properties }, index) => {
    const name = properties?.name
    indexesByName.set(name, [...(indexesByName.get(name) || []), index])
  })

  return [...indexesByName.values()].filter(indexes => indexes.length > 1).flat()
}
